import axios from 'axios'
// const { NODE_ENV } = process.env;
import localStorageContent from '../services/localStorage';

const getToken = () => {
    const localData = localStorageContent.getLocalUserData()
    if (localData === undefined) {
        return ''
    } else if (localData.access === null) {
        return ''
    } else {
        return localData.access.token
    }
}

const URL = axios.create({
    // baseURL: "https://v4.efone.ca/v1",
    baseURL: process.env.REACT_APP_API_URL,
})
 

// var local_user = localStorage.getItem("current_user")
// var current_user = local_user ? JSON.parse(local_user) : {}
// export const headersWithToken = {
//     headers: {
//         'Authorization': current_user ? current_user.token : ""
//     }
// }
URL.interceptors.request.use(
    async config => {
        config.headers = {
            'Authorization': `Bearer ${getToken()}`
        }
        return config
    },
    error => {
        Promise.reject(error)
    }
)
export default URL